import { useCallback, useState } from 'react';

import type { NoTherapyConfirmParams } from './types';

export default function useNoTherapyConfirm({
  hasSavedTherapies,
  clearAll,
  setNoTherapies,
}: NoTherapyConfirmParams) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleToggle = useCallback(
    (checked: boolean) => {
      if (!checked) {
        void setNoTherapies(false);
        return;
      }
      setIsConfirmOpen(true);
    },
    [setNoTherapies],
  );

  const handleConfirm = useCallback(async () => {
    // When a bulk delete exists, wait for it so the flag is not set after a failed clear.
    if (hasSavedTherapies && clearAll && !(await clearAll())) return;
    if (await setNoTherapies(true)) setIsConfirmOpen(false);
  }, [clearAll, hasSavedTherapies, setNoTherapies]);

  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  return { isConfirmOpen, handleToggle, handleConfirm, closeConfirm };
}
